module.exports = __webpack_public_path__ + "img/newLogo.12d03f4e.png";